import React, { useEffect, useRef, useState } from 'react';
import { jsonEditorStyles } from '../jsonEditorStyles';
import Button from '@mui/material/Button';
import cn from 'clsx';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import useComponentUIHook from './useComponentUIHook';
import useJSONEditorHook from '../useJSONEditorHook';
import { SelectComponent, TextComponent, TooltipComponent } from '../../uiComponents';
import { Radio, RadioGroup, SelectChangeEvent } from '@mui/material';
import { OptionProps } from '../../../view-models';
import { getCurrentTabId, getFlowcharts, getJSONClaims, getNodeData, setJSONClaims } from '../../../store';
import CONSTANTS from '../../../constants/constants';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditOutlineSharpIcon from '@mui/icons-material/ModeEditOutlineSharp';
import { cloneDeep } from 'lodash';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import SessionManagement from './sessionManagement';
import jsonComponents from '../../../constants/jsonComponents';
import { useSelector, useDispatch } from 'react-redux';
import { init_UserInputPageComponent } from '../init_components';
import constants from '../../../constants/constants';
import jsonConstants from '../../../constants/jsonConstants';
import { convertCompilerOptionsFromJson } from 'typescript';
import { FieldMapperRow } from './fieldMapperRow';

const styles1 = makeStyles((theme: Theme) =>
  createStyles({
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
    },
    flexColfill: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '100%',
      flex: '1',
      padding: '2px',
      overflow: 'hidden',
      '& .inline-tooltip': {
        marginTop: '10px',
      },
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    attribute: {
      borderBottom: '1px solid grey',
      padding: 10,
    },
    pointer: {
      cursor: 'pointer',
    },
    icon: {
      cursor: 'pointer',
      marginLeft: '0.5rem',
    },
    justifyContent: {
      justifyContent: 'space-between',
    },
    marginRight: { marginRight: '20px' },
    marginLeft: { marginLeft: '20px' },
    displayAttribute: {
      flex: 1,
    },
    actions: {
      width: 90,
    },
  }),
);

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}

const GenerateSendEmailOTPUI = ({ componentData, closeGritComponent, setUnsavedChanges }: componentProps) => {
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows } = useComponentUIHook(componentData);
  const configData = jsonComponents.sendEmailOTP;
  let [claimsList, setClaimsList] = useState<OptionProps[]>([]);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [nextItem, setNextItem] = useState<any>({
    sourceType: '',
    source: '',
    templateField: '',
  });
  const currentTabId = useSelector(getCurrentTabId);
  const flowcharts = useSelector(getFlowcharts);
  const nodeData = useSelector(getNodeData);

  const allClaims = useSelector(getJSONClaims);

  const classes = styles1();
  const classes1 = jsonEditorStyles();

  useEffect(() => {
    nodeData &&
      currentTabId &&
      Object.values(nodeData).forEach((v: any) => {
        if (v.emailVerificationSendAction?.id === currentTabId) {
          setModifiedData({
            ...modifiedData,
            emailClaim:
              v.email.valEmailType === 'newEmail'
                ? v.email.newEmail.attributeSource
                : v.email.valPrevEmail.emailAttribute,
          });
        }
      });
  }, [currentTabId, flowcharts, nodeData]);

  useEffect(() => {
    if (Object.keys(allClaims).length > 0) {
      const _temp = Object.keys(allClaims)
        .filter((clm: any) => {
          return ['string', 'boolean'].includes(allClaims[clm].dataType);
        })
        .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
        .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1));
      setClaimsList(_temp);
    }
  }, [allClaims]);

  const onDeleteHandler = (index: number) => {
    const _fields = modifiedData['fields'].reduce((acc: any[], item: any, ind: number) => {
      return ind === index ? acc : acc.concat(item);
    }, []);
    setModifiedData({
      ...modifiedData,
      fields: _fields,
    });
  };

  const submitData = (data: any) => {
    setDisableSubmit(false);
    closeGritComponent(data, null, false);
  };

  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows([]);
    setDisableSubmit(
      _res ||
        !(
          modifiedData['emailTemplate'] &&
          modifiedData['emailClaim'] &&
          modifiedData['otpField'] &&
          (!modifiedData['fields'] ||
            modifiedData['fields'].every((fld: any) => {
              return fld['sourceType'] && (fld['sourceType'] === 'literal' || fld['source']) && fld['templateField'];
            }))
        ),
    );
    setUnsavedChanges(_res);
  }, [modifiedData]);

  return (
    <div>
      <div className={classes1.subHeading}>Email Settings</div>
      <div className={classes.flexRow}>
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<string>) => {
            setModifiedData({ ...modifiedData, emailTemplate: e.target.value });
          }}
          data={{
            value: modifiedData['emailTemplate'] ? modifiedData['emailTemplate'] : '',
            label: 'Email Template',
            style: { margin: 1, width: 400 },
            options: jsonConstants.emailOTPTemplates.map((ot) => {
              return { value: ot.id, label: ot.name };
            }),
          }}
        />
        <TooltipComponent
          title="Email Templates"
          desc="These default templates have the following customizable, optional fields: subject, email, givenname, servicename, timestamp, timeout, timezone. These names can be used for template field mappings below."
        />
        {/*<TextComponent
          changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            setModifiedData({ ...modifiedData, emailTemplate: e.target.value });
          }}
          data={{
            value: modifiedData['emailTemplate'] ? modifiedData['emailTemplate'] : '',
            label: 'Email Template',
            style: { margin: 1, width: 500 },
          }}
        />*/}
      </div>
      <FieldMapperRow
        rowData={modifiedData['language']}
        writeback={(newLang: any) => {
          setModifiedData({ ...modifiedData, language: newLang });
        }}
        claimsList={claimsList.filter((clm) => {
          return allClaims[clm.value].dataType === 'string';
        })}
        sourceTypeFieldName="sourceType"
        sourceTypeFieldLabel="Language Source"
        sourceFieldName="source"
        sourceFieldLabels={{ claim: 'Language Claim', literal: 'Language String', resolver: 'Session Context' }}
      />
      <div className={classes.flexRow}>
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<string>) => {
            setModifiedData({ ...modifiedData, emailClaim: e.target.value });
          }}
          data={{
            value: modifiedData['emailClaim'] ? modifiedData['emailClaim'] : '',
            label: 'Email Destination',
            style: { margin: 1, width: 250 },
            disabled: true,
            options: claimsList.filter((clm) => {
              return allClaims[clm.value].dataType === 'string';
            }),
          }}
        />
      </div>
      <div className={classes1.subHeading}>Email Template Fields</div>
      <div className={classes.flexRow}>
        <TextComponent
          changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            setModifiedData({ ...modifiedData, otpField: e.target.value });
          }}
          data={{
            value: modifiedData['otpField'] ? modifiedData['otpField'] : '',
            label: 'OTP Template Field',
            style: { margin: 1, width: 250 },
            disabled: true, // For current state
          }}
        />
      </div>
      {modifiedData['fields'] &&
        modifiedData['fields'].map((fInfo: any, idx: number) => {
          return (
            <FieldMapperRow
              rowData={modifiedData['fields'][idx]}
              writeback={(updatedRow) => {
                const updatedFields = modifiedData['fields'].slice();
                updatedFields[idx] = updatedRow;
                setModifiedData({
                  ...modifiedData,
                  fields: updatedFields,
                });
              }}
              claimsList={claimsList}
              sourceTypeFieldName="sourceType"
              sourceTypeFieldLabel="Data Source"
              sourceFieldName="source"
              sourceFieldLabels={{ claim: 'Source Claim', literal: 'Field Value', resolver: 'Session Context' }}
              partnerTypeFieldName="templateField"
              partnerTypeFieldLabel="Template Field ID"
              buttonText="Delete"
              buttonAction={() => {
                onDeleteHandler(idx);
              }}
            />
          );
        })}
      <FieldMapperRow
        rowData={nextItem}
        writeback={setNextItem}
        claimsList={claimsList}
        sourceTypeFieldName="sourceType"
        sourceTypeFieldLabel="Data Source"
        sourceFieldName="source"
        sourceFieldLabels={{ claim: 'Source Claim', literal: 'Field Value', resolver: 'Session Context' }}
        partnerTypeFieldName="templateField"
        partnerTypeFieldLabel="Template Field ID"
        buttonText="Add"
        buttonAction={() => {
          const updatedFields = modifiedData['fields'] ? modifiedData['fields'].slice() : [];
          updatedFields.push({
            sourceType: nextItem['sourceType'],
            source: nextItem['source'],
            templateField: nextItem['templateField'],
          });
          setModifiedData({
            ...modifiedData,
            fields: updatedFields,
          });
          setNextItem({ sourceType: '', source: '', templateField: '' });
        }}
        buttonDisabled={
          !(
            nextItem['sourceType'] &&
            (nextItem['sourceType'] === 'literal' || nextItem['source']) &&
            nextItem['templateField']
          )
        }
      />
      <div>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            submitData(cloneDeep(modifiedData));
          }}
          disabled={disableSubmit}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default GenerateSendEmailOTPUI;
